<script>
  /**Components*/
  import NaPicture from "../../components/global/NA_Picture.svelte";
  import ShoppingCartQtyBox from "./ShoppingCartQtyBox.svelte";
  /**Utils*/
  import { cart } from "$lib/state/cart";
  import { cartTotals } from "$lib/state/cartTotals";
  import {
    DELETE_ITEM_FROM_CART_EVENT,
    dispatchCustomEvent,
  } from "$lib/utils/events";
  import { klaviyoDeleteProduct } from "$lib/utils/KlaviyoEvents";

  /** @typedef {import('$lib/types').MagentoCart} MagentoCart */
  /** @typedef {import('$lib/types').MagentoCartItem} MagentoCartItem */
  /** @typedef {import('$lib/types').CartResponse} CartResponse */

  /** @type {MagentoCartItem} */
  export let cartItem;
  export let size = "";
  /**@type {?MagentoCart}*/
  let shoppingCart = $cart;

  let isDelete = false;
  let noDelete = false;
  async function removeItem() {
    isDelete = true;
    try {
      const responseStream = await fetch(`/cart?itemId=${cartItem.item_id}`, {
        method: "DELETE",
      });
      /** @type {CartResponse} */
      const response = await responseStream.json();
      klaviyoDeleteProduct(cartItem, cartItem.qty)
      if (responseStream.status == 200) {
        dispatchCustomEvent(
          DELETE_ITEM_FROM_CART_EVENT,
          shoppingCart,
          cartItem.item_id
        );
        cart.set(response.cart);
        cartTotals.set(response.cartTotals);
        return;
      } else {
        noDelete = true;
      }

      throw new Error(/** @type {any} */ (response));
    } catch (error) {
      console.error(error);
    } finally {
      isDelete = false;
    }
  }
</script>

<div class={`shopping-cart-row ${size}`} class:delete={isDelete} class:noDelete>
  {#if cartItem?.images?.small}
    <div class="product-image">
      {#if size == "small"}
        <NaPicture
          width={"60"}
          borderRadius={0}
          source={cartItem?.images?.small}
        />
      {:else}
        <NaPicture
          width={"360"}
          borderRadius={0}
          source={cartItem?.images?.small}
        />
      {/if}
    </div>
  {:else}
    <div class="product-image">
      {#if size == "small"}
        <NaPicture
          width={"60"}
          borderRadius={0}
          source={cartItem?.images?.image}
        />
      {:else}
        <NaPicture
          width={"360"}
          borderRadius={0}
          source={cartItem?.images?.image}
        />
      {/if}
    </div>
  {/if}
  <div class="product-info">
    <p class="item-number">{cartItem.sku}</p>
    <div class="product-name">{@html cartItem.name}</div>
    <div class="product-price">
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cartItem.price)}
    </div>
  </div>
  <div class="product-remove">
    <button
      type="button"
      on:click={removeItem}
      aria-labelledby="action_button_product-remove"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        id="trash-can"
      >
        <path
          d="M9.547,23.585a1.46,1.46,0,0,1-1.067-.453,1.49,1.49,0,0,1-.453-1.093V7.532H6.933v-1.2h4.56V5.585h6.88v.747h4.56v1.2H21.84V22.039a1.49,1.49,0,0,1-.453,1.093,1.46,1.46,0,0,1-1.067.453ZM20.64,7.532H9.227V22.039a.342.342,0,0,0,.093.253.309.309,0,0,0,.227.093H20.32a.307.307,0,0,0,.213-.107.332.332,0,0,0,.107-.24ZM12.293,20.119H13.52V9.772H12.293Zm4.053,0h1.227V9.772H16.347ZM9.227,7.532v0Z"
          transform="translate(-6.933 -5.585)"
        />
      </svg>
    </button>
  </div>
  <div class="product-qty">
    <ShoppingCartQtyBox
      qty={cartItem.qty}
      {size}
      itemId={cartItem.item_id}
      sku={cartItem.sku}
    />
  </div>
</div>

<style>
  button {
    background: none;
    border: none;
    cursor: pointer;
  }

  .shopping-cart-row {
    --font-size: 1rem;
    --trash-can-width: 16px;
  }

  .shopping-cart-row.small {
    --font-size: 0.725rem;
    --trash-can-width: 11px;
  }

  #trash-can {
    width: var(--trash-can-width, 16px);
  }

  .shopping-cart-row {
    display: grid;
    grid-template-columns: minmax(80px, 1fr) 4fr auto;
    grid-template-rows: 1fr auto;
    grid-template-areas: "picture product remove" "picture qty empty";
    column-gap: 15px;
    font-size: var(--font-size);
    align-items: start;
  }

  .product-image {
    aspect-ratio: 1/1;
    border-radius: 17px;
    border: 1px solid #707070;
    overflow: hidden;
    grid-area: picture;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 180px;
  }

  :global(.shopping-cart-row .container-pictures) {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-info.s-CKH908S4ajsV {
    grid-area: product;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .item-number {
    font-size: 1rem;
    font-weight: 200;
  }

  .product-name {
    font-size: 0.875rem;
    font-weight: 700;
    padding: 10px 0;
  }

  .product-price {
    font-size: 1.5rem;
    font-weight: 200;
  }

  .product-qty {
    grid-area: qty;
  }

  .product-remove {
    grid-area: remove;
    align-self: start;
  }
  .product-remove button svg {
    transition: all 0.5s ease;
  }
  .product-remove button svg:hover {
    fill: #d03953;
  }
  .offer-container {
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0 0 10px 0;
    margin-top: 10px;
  }
  .delete {
    animation: delete 300ms ease-in forwards;
  }
  .noDelete {
    animation: restore 300ms ease-in forwards;
  }
  @keyframes delete {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    98% {
      transform: translateX(200%);
      opacity: 0;
    }
    100% {
      transform: translateX(200%);
      opacity: 0;
      display: none;
    }
  }
  @keyframes restore {
    0% {
      display: initial;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @media (min-width: 768px) {
    .product-name {
      font-size: 1.2rem;
    }
    .item-number {
      font-size: 1.2rem;
    }
    .product-price {
      font-size: 2rem;
    }
    .small .product-name{
      font-size: 1rem!important;
    }
    .small .item-number{
      font-size: 1rem!important;
    }
    .small .product-price{
      font-size: 1.2rem;
    }
  }
</style>
